import {
  COMMERCIAL_OPERATION_STATUS_LABELS,
  type CommercialOperationStatus,
} from '@/modules/commercial/types';

const STATUS_CLASS: Record<CommercialOperationStatus, string> = {
  draft: 'commercial-badge--draft',
  pending: 'commercial-badge--pending',
  approved: 'commercial-badge--approved',
  rejected: 'commercial-badge--rejected',
  in_progress: 'commercial-badge--in-progress',
  completed: 'commercial-badge--completed',
  cancelled: 'commercial-badge--cancelled',
};

type CommercialStatusBadgeProps = {
  status: CommercialOperationStatus;
};

export function CommercialStatusBadge({ status }: CommercialStatusBadgeProps) {
  return (
    <span className={`commercial-badge ${STATUS_CLASS[status]}`}>
      {COMMERCIAL_OPERATION_STATUS_LABELS[status]}
    </span>
  );
}
